export default __webpack_public_path__ + "static/media/quiz-pic-2.b7389d79.jpeg";